import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { columnDetailApi } from "../apis/column";
import { ColumnDetail } from "../types";

const useGetColumnDetail = (contentSeq: number) => {
    return useQuery<AxiosResponse<ColumnDetail>, Error>(['columnDetail', contentSeq], () => columnDetailApi(contentSeq),
        {
            retryDelay: 600000
            , refetchOnWindowFocus: false
        });
}

export default useGetColumnDetail;